import { resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "slot-content" }
const _hoisted_2 = { class: "toolbar" }
const _hoisted_3 = { style: { display: 'inline-block', 'padding-right': '16px' } }
const _hoisted_4 = { style: { display: 'inline-block', 'padding-right': '16px' } }
const _hoisted_5 = { style: { display: 'inline-block', 'padding-right': '16px' } }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" export ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_8 = { class: "data-table" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("th", { class: "with-border" }, " ", -1)
const _hoisted_10 = ["colspan"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Std comm rev ≤ 12mo ")
const _hoisted_12 = {
  key: 0,
  class: "k-icon k-font-icon k-i-minus-outline"
}
const _hoisted_13 = {
  key: 1,
  class: "k-icon k-font-icon k-i-plus-outline"
}
const _hoisted_14 = ["colspan"]
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Std comm rev > 12mo ")
const _hoisted_16 = {
  key: 0,
  class: "k-icon k-font-icon k-i-minus-outline"
}
const _hoisted_17 = {
  key: 1,
  class: "k-icon k-font-icon k-i-plus-outline"
}
const _hoisted_18 = ["colspan"]
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Transferred rev ")
const _hoisted_20 = {
  key: 0,
  class: "k-icon k-font-icon k-i-minus-outline"
}
const _hoisted_21 = {
  key: 1,
  class: "k-icon k-font-icon k-i-plus-outline"
}
const _hoisted_22 = {
  key: 0,
  colspan: "2",
  class: "with-border",
  style: {"text-align":"center"}
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center"} }, "Total payable", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("th", { class: "with-border" }, "Client", -1)
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("th", null, "Commissionable", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("th", { class: "with-border" }, "Commission", -1)
const _hoisted_29 = { key: 2 }
const _hoisted_30 = { key: 3 }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Refunds\\")
const _hoisted_32 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_33 = /*#__PURE__*/_createTextVNode("Cancellations")
const _hoisted_34 = [
  _hoisted_31,
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("th", null, "Commissionable", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("th", { class: "with-border" }, "Commission", -1)
const _hoisted_37 = { key: 4 }
const _hoisted_38 = { key: 5 }
const _hoisted_39 = /*#__PURE__*/_createTextVNode("Refunds\\")
const _hoisted_40 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_41 = /*#__PURE__*/_createTextVNode("Cancellations")
const _hoisted_42 = [
  _hoisted_39,
  _hoisted_40,
  _hoisted_41
]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("th", null, "Commissionable", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("th", { class: "with-border" }, "Commission", -1)
const _hoisted_45 = { key: 6 }
const _hoisted_46 = {
  key: 7,
  class: "with-border"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("th", null, "Commission", -1)
const _hoisted_48 = { style: {"background-color":"#fcfcf2"} }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("td", { class: "with-border" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Total")
], -1)
const _hoisted_50 = {
  key: 0,
  class: "total"
}
const _hoisted_51 = {
  key: 1,
  class: "total"
}
const _hoisted_52 = { class: "total" }
const _hoisted_53 = { class: "total with-border" }
const _hoisted_54 = {
  key: 2,
  class: "total"
}
const _hoisted_55 = {
  key: 3,
  class: "total"
}
const _hoisted_56 = { class: "total" }
const _hoisted_57 = { class: "total with-border" }
const _hoisted_58 = {
  key: 4,
  class: "total"
}
const _hoisted_59 = {
  key: 5,
  class: "total"
}
const _hoisted_60 = { class: "total" }
const _hoisted_61 = { class: "total with-border" }
const _hoisted_62 = {
  key: 6,
  class: "total"
}
const _hoisted_63 = {
  key: 7,
  class: "total with-border"
}
const _hoisted_64 = { class: "total" }
const _hoisted_65 = { class: "with-border" }
const _hoisted_66 = { class: "client-fullname" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_68 = { class: "client-email" }
const _hoisted_69 = {
  key: 0,
  class: "money"
}
const _hoisted_70 = {
  key: 1,
  class: "money"
}
const _hoisted_71 = { class: "money" }
const _hoisted_72 = { class: "money with-border" }
const _hoisted_73 = {
  key: 2,
  class: "money"
}
const _hoisted_74 = {
  key: 3,
  class: "money"
}
const _hoisted_75 = { class: "money" }
const _hoisted_76 = { class: "money with-border" }
const _hoisted_77 = {
  key: 4,
  class: "money"
}
const _hoisted_78 = {
  key: 5,
  class: "money"
}
const _hoisted_79 = { class: "money" }
const _hoisted_80 = { class: "money with-border" }
const _hoisted_81 = {
  key: 6,
  class: "money"
}
const _hoisted_82 = {
  key: 7,
  class: "money with-border"
}
const _hoisted_83 = { class: "money" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_change_client_manager_info = _resolveComponent("change-client-manager-info")!
  const _component_recalculate_commissions_modal = _resolveComponent("recalculate-commissions-modal")!
  const _component_view_audit_modal = _resolveComponent("view-audit-modal")!
  const _component_KDropDownList = _resolveComponent("KDropDownList")!
  const _component_KButton = _resolveComponent("KButton")!
  const _component_KSplitButton = _resolveComponent("KSplitButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_component_change_client_manager_info, {
        show: _ctx.showActionModal == 'changeClientManagerInfo',
        "client-manager": _ctx.currentClientManager,
        onCloseModal: _ctx.onCloseModal,
        onCommandExecuted: _ctx.onCommandExecuted
      }, null, 8, ["show", "client-manager", "onCloseModal", "onCommandExecuted"]),
      _createVNode(_component_recalculate_commissions_modal, {
        show: _ctx.showActionModal == 'recalculateCommissions',
        "client-manager": _ctx.currentClientManager,
        model: null,
        "user-kind": 'manager',
        onCloseModal: _ctx.onCloseModal,
        onCommandExecuted: _ctx.onCommandExecuted
      }, null, 8, ["show", "client-manager", "onCloseModal", "onCommandExecuted"]),
      _createVNode(_component_view_audit_modal, {
        show: _ctx.showActionModal == 'viewAudit',
        "client-manager": _ctx.currentClientManager,
        model: null,
        onCloseModal: _ctx.onCloseModal,
        onCommandExecuted: _ctx.onCommandExecuted
      }, null, 8, ["show", "client-manager", "onCloseModal", "onCommandExecuted"])
    ])),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_KDropDownList, {
            value: _ctx.selectedMonth,
            style: { width: '100px' },
            "data-items": _ctx.months,
            "text-field": 'text',
            "data-item-key": 'id',
            "default-item": 'Select an month ...',
            onChange: _ctx.onMonthChanged
          }, null, 8, ["value", "data-items", "default-item", "onChange"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_KDropDownList, {
            value: _ctx.selectedClientManager,
            style: { width: '250px' },
            "data-items": _ctx.clientManagers,
            "text-field": 'FullName',
            "data-item-key": 'Id',
            onChange: _ctx.onSalesRepChanged
          }, null, 8, ["value", "data-items", "onChange"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_KButton, {
            "icon-class": 'k-icon k-i-excel',
            onClick: _ctx.onExportItemClicked
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["onClick"]),
          _hoisted_7,
          (_ctx.inAdminRole)
            ? (_openBlock(), _createBlock(_component_KSplitButton, {
                key: 0,
                "icon-class": 'k-icon k-i-gear',
                "text-field": 'label',
                items: _ctx.actions,
                "fill-mode": 'flat',
                onItemclick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onActionClicked($event)))
              }, null, 8, ["items"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("table", null, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _hoisted_9,
              _createElementVNode("th", {
                colspan: _ctx.colspanLte12Mo,
                class: "with-border",
                style: {"text-align":"center"}
              }, [
                _hoisted_11,
                _createElementVNode("a", {
                  class: "expand-toggle",
                  href: "#",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onToggleExpandLte12Mo && _ctx.onToggleExpandLte12Mo(...args)))
                }, [
                  (_ctx.expandLte12Mo)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12))
                    : (_openBlock(), _createElementBlock("span", _hoisted_13))
                ])
              ], 8, _hoisted_10),
              _createElementVNode("th", {
                colspan: _ctx.colspanGt12Mo,
                class: "with-border",
                style: {"text-align":"center"}
              }, [
                _hoisted_15,
                _createElementVNode("a", {
                  class: "expand-toggle",
                  href: "#",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onToggleExpandGt12Mo && _ctx.onToggleExpandGt12Mo(...args)))
                }, [
                  (_ctx.expandGt12Mo)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16))
                    : (_openBlock(), _createElementBlock("span", _hoisted_17))
                ])
              ], 8, _hoisted_14),
              _createElementVNode("th", {
                colspan: _ctx.colspanTranferred,
                class: "with-border",
                style: {"text-align":"center"}
              }, [
                _hoisted_19,
                _createElementVNode("a", {
                  class: "expand-toggle",
                  href: "#",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onToggleExpandTransferred && _ctx.onToggleExpandTransferred(...args)))
                }, [
                  (_ctx.expandTransferred)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20))
                    : (_openBlock(), _createElementBlock("span", _hoisted_21))
                ])
              ], 8, _hoisted_18),
              (_ctx.hasZeroCommRevenuesTotal)
                ? (_openBlock(), _createElementBlock("th", _hoisted_22, " Zero comm rev "))
                : _createCommentVNode("", true),
              _hoisted_23
            ]),
            _createElementVNode("tr", null, [
              _hoisted_24,
              (_ctx.expandLte12Mo)
                ? (_openBlock(), _createElementBlock("th", _hoisted_25, "Revenue"))
                : _createCommentVNode("", true),
              (_ctx.expandLte12Mo)
                ? (_openBlock(), _createElementBlock("th", _hoisted_26, "Ref.\\Canc."))
                : _createCommentVNode("", true),
              _hoisted_27,
              _hoisted_28,
              (_ctx.expandGt12Mo)
                ? (_openBlock(), _createElementBlock("th", _hoisted_29, "Revenue"))
                : _createCommentVNode("", true),
              (_ctx.expandGt12Mo)
                ? (_openBlock(), _createElementBlock("th", _hoisted_30, _hoisted_34))
                : _createCommentVNode("", true),
              _hoisted_35,
              _hoisted_36,
              (_ctx.expandTransferred)
                ? (_openBlock(), _createElementBlock("th", _hoisted_37, "Revenue"))
                : _createCommentVNode("", true),
              (_ctx.expandTransferred)
                ? (_openBlock(), _createElementBlock("th", _hoisted_38, _hoisted_42))
                : _createCommentVNode("", true),
              _hoisted_43,
              _hoisted_44,
              (_ctx.hasZeroCommRevenuesTotal)
                ? (_openBlock(), _createElementBlock("th", _hoisted_45, "Revenue"))
                : _createCommentVNode("", true),
              (_ctx.hasZeroCommRevenuesTotal)
                ? (_openBlock(), _createElementBlock("th", _hoisted_46, " Commission "))
                : _createCommentVNode("", true),
              _hoisted_47
            ])
          ]),
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", _hoisted_48, [
              _hoisted_49,
              (_ctx.expandLte12Mo)
                ? (_openBlock(), _createElementBlock("td", _hoisted_50, _toDisplayString(_ctx.stdCommRevLe12MoRevenuesTotalFmt), 1))
                : _createCommentVNode("", true),
              (_ctx.expandLte12Mo)
                ? (_openBlock(), _createElementBlock("td", _hoisted_51, _toDisplayString(_ctx.stdCommRevLe12MoDeductionsTotalFmt), 1))
                : _createCommentVNode("", true),
              _createElementVNode("td", _hoisted_52, _toDisplayString(_ctx.stdCommRevLe12MoCommissionableTotalFmt), 1),
              _createElementVNode("td", _hoisted_53, _toDisplayString(_ctx.stdCommRevLe12MoCommissionTotalFmt), 1),
              (_ctx.expandGt12Mo)
                ? (_openBlock(), _createElementBlock("td", _hoisted_54, _toDisplayString(_ctx.stdCommRevGt12MoRevenuesTotalFmt), 1))
                : _createCommentVNode("", true),
              (_ctx.expandGt12Mo)
                ? (_openBlock(), _createElementBlock("td", _hoisted_55, _toDisplayString(_ctx.stdCommRevGt12MoDeductionsTotalFmt), 1))
                : _createCommentVNode("", true),
              _createElementVNode("td", _hoisted_56, _toDisplayString(_ctx.stdCommRevGt12MoCommissionableTotalFmt), 1),
              _createElementVNode("td", _hoisted_57, _toDisplayString(_ctx.stdCommRevGt12MoCommissionTotalFmt), 1),
              (_ctx.expandTransferred)
                ? (_openBlock(), _createElementBlock("td", _hoisted_58, _toDisplayString(_ctx.transferredRevenuesTotalFmt), 1))
                : _createCommentVNode("", true),
              (_ctx.expandTransferred)
                ? (_openBlock(), _createElementBlock("td", _hoisted_59, _toDisplayString(_ctx.transferredDeductionsTotalFmt), 1))
                : _createCommentVNode("", true),
              _createElementVNode("td", _hoisted_60, _toDisplayString(_ctx.transferredCommissionableTotalFmt), 1),
              _createElementVNode("td", _hoisted_61, _toDisplayString(_ctx.transferredCommissionTotalFmt), 1),
              (_ctx.hasZeroCommRevenuesTotal)
                ? (_openBlock(), _createElementBlock("td", _hoisted_62, _toDisplayString(_ctx.zeroCommRevenuesTotalFmt), 1))
                : _createCommentVNode("", true),
              (_ctx.hasZeroCommRevenuesTotal)
                ? (_openBlock(), _createElementBlock("td", _hoisted_63, _toDisplayString(_ctx.zeroCommCommissionTotalFmt), 1))
                : _createCommentVNode("", true),
              _createElementVNode("td", _hoisted_64, _toDisplayString(_ctx.totalPayableCommissionsTotalFmt), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fmtLines, (item, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: index,
                class: _normalizeClass({ odd: index % 2 != 0 })
              }, [
                _createElementVNode("td", _hoisted_65, [
                  _createElementVNode("span", _hoisted_66, _toDisplayString(item.Client), 1),
                  _hoisted_67,
                  _createElementVNode("span", _hoisted_68, _toDisplayString(item.Email), 1)
                ]),
                (_ctx.expandLte12Mo)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_69, _toDisplayString(item.StdCommRevLe12MoRevenues), 1))
                  : _createCommentVNode("", true),
                (_ctx.expandLte12Mo)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_70, _toDisplayString(item.StdCommRevLe12MoDeductions), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("td", _hoisted_71, _toDisplayString(item.StdCommRevLe12MoCommissionable), 1),
                _createElementVNode("td", _hoisted_72, _toDisplayString(item.StdCommRevLe12MoCommission), 1),
                (_ctx.expandGt12Mo)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_73, _toDisplayString(item.StdCommRevGt12MoRevenues), 1))
                  : _createCommentVNode("", true),
                (_ctx.expandGt12Mo)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_74, _toDisplayString(item.StdCommRevGt12MoDeductions), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("td", _hoisted_75, _toDisplayString(item.StdCommRevGt12MoCommissionable), 1),
                _createElementVNode("td", _hoisted_76, _toDisplayString(item.StdCommRevGt12MoCommission), 1),
                (_ctx.expandTransferred)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_77, _toDisplayString(item.TransferredRevenues), 1))
                  : _createCommentVNode("", true),
                (_ctx.expandTransferred)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_78, _toDisplayString(item.TransferredDeductions), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("td", _hoisted_79, _toDisplayString(item.TransferredCommissionable), 1),
                _createElementVNode("td", _hoisted_80, _toDisplayString(item.TransferredCommission), 1),
                (_ctx.hasZeroCommRevenuesTotal)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_81, _toDisplayString(item.ZeroCommRevenues), 1))
                  : _createCommentVNode("", true),
                (_ctx.hasZeroCommRevenuesTotal)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_82, _toDisplayString(item.ZeroCommCommission), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("td", _hoisted_83, _toDisplayString(item.TotalPayableCommissions), 1)
              ], 2))
            }), 128))
          ])
        ])
      ])
    ])
  ], 64))
}